import { T as d, j as c } from "./index-2269cfe0.js";
import { useContext as u, createContext as $ } from "react";
import h from "react-inlinesvg";
import { c as f } from "./WCLComponent.styles-68ac5b1f.js";
import { css as y, keyframes as m } from "styled-components";
import { r as l } from "./polished.esm-7edc4d30.js";
const K = d(({ fill: o, viewBox: s, height: t, width: r, className: e, testId: n, children: a, onClick: i }) => /* @__PURE__ */ c.jsx("svg", {
  className: e,
  "data-testid": n,
  fill: o,
  viewBox: s,
  height: t,
  width: r,
  onClick: i,
  children: a
}))`
  ${f}
`, v = d(({ className: o, testId: s, onClick: t, size: r, src: e, role: n, domProps: a }) => /* @__PURE__ */ c.jsx(h, {
  role: n,
  width: r,
  src: e,
  height: r,
  onClick: t,
  className: o,
  "data-testid": s,
  ...a
}))`
  ${({ fillColor: o, strokeColor: s }) => y`
      * {
        fill: ${o};
        stroke: ${s};
      }
    `}
`, x = /* @__PURE__ */ $({}), N = x.Provider, C = "https://qa4-static-mgmresorts.devtest.vegas/content/dam/MGM/mgmresorts/icons/gen3/svg/", j = "https://static.mgmresorts.com/content/dam/MGM/mgmresorts/icons/gen3/svg/", T = ({ fillColor: o, strokeColor: s, size: t, name: r, onClick: e, domProps: n, role: a, testId: i = r }) => {
  const { env: k } = u(x), g = k === "prod" ? j : C;
  return /* @__PURE__ */ c.jsx(v, {
    testId: `${i}-icon`,
    src: `${g}/${r}-icon.svg`,
    size: t,
    role: a,
    fillColor: o,
    strokeColor: s,
    onClick: e,
    domProps: n
  });
}, p = 1.3, S = m`
  0% {
    stroke: currentColor;
  }
  25% {
    stroke: currentColor;
  }
  50% {
    stroke: currentColor;
  }
  75% {
    stroke: currentColor;
  }
  100% {
    stroke: currentColor;
  }
`, I = m`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }
  100% {
    stroke-dasharray: 0px, 200px;
    stroke-dashoffset: -125px;
  }
`, w = d(({ fill: o, viewBox: s, height: t, width: r, className: e, testId: n, children: a }) => /* @__PURE__ */ c.jsx("svg", {
  className: e,
  "data-testid": n,
  fill: o,
  viewBox: s,
  height: t,
  width: r,
  children: a
}))`
  ${f}
  circle.background {
    stroke-dashoffset: 0;
    ${({ theme: o }) => `
      color: ${l(o.colors.white, 0.3)};
      stroke: ${l(o.colors.white, 0.3)};
    `}
  }

  circle.spinner {
    stroke-dashoffset: 0;
    stroke-dasharray: 80px, 200px;
    animation: ${I} ${p}s ease-in-out infinite,
      ${S} ${p * 4}s ease-in-out infinite;
    ${({ color: o, theme: s }) => `
      color: ${o || s.colors.interface};
      stroke: ${o || s.colors.interface};
    `};
  }
`, U = ({ testId: o = "loading-spinner-icon", showSpinnerBackground: s = !1, strokeWidth: t = 4, size: r = "100%", ...e }) => /* @__PURE__ */ c.jsxs(w, {
  fill: "none",
  viewBox: "20 20 48 48",
  testId: o,
  height: r,
  width: r,
  ...e,
  children: [
    s && /* @__PURE__ */ c.jsx("circle", {
      "data-testid": `${o}-background`,
      strokeWidth: t,
      className: "background",
      fill: "none",
      strokeLinecap: "round",
      cx: "44",
      cy: "44",
      r: "20.2"
    }),
    /* @__PURE__ */ c.jsx("circle", {
      "data-testid": `${o}-spinner`,
      strokeWidth: t,
      className: "spinner",
      fill: "none",
      strokeLinecap: "round",
      cx: "44",
      cy: "44",
      r: "20.2"
    })
  ]
});
export {
  N as I,
  U as L,
  K as S,
  T as a
};
